// extracted by mini-css-extract-plugin
export default {"wrapper":"JackpotInBanner_wrapper--OP2","jackpotsItemsWrapper":"JackpotInBanner_jackpotsItemsWrapper--_oz","jackpotItem":"JackpotInBanner_jackpotItem--aEc"};